// extracted by mini-css-extract-plugin
export default {"main":"_93bbae861b _7600413a23","xmark":"_5174b7dcba","fl_img":"_8edaa50b88 _354ed33391"};